import { createBrowserHistory } from "history";
import { Provider } from "mobx-react";
import { syncHistoryWithStore } from "mst-react-router";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import App from "./App";
import { AuthProvider, IUser } from "./components/Auth";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import { MainStore } from "./stores/MainStore";

declare global {
  interface Window {
    location: Location;
    BASEPATH: string;
    USER_ENDPOINT: string;
    USER: IUser | null;
    BACKEND_ENDPOINT: string;
  }
}

fetch(`${window.USER_ENDPOINT}`)
  .then(res => {
    if (!res.ok) {
      throw new Error('Cannot get user');
    }
    return res.json();
  })
  .then((res) => {
    const { user } = res;
    const store = new MainStore(user);
    const history = syncHistoryWithStore(
      createBrowserHistory({ basename: window.BASEPATH }),
      store.router
    );

    ReactDOM.render(
      <Provider store={store}>
        <Router history={history}>
          <AuthProvider endpoint={window.USER_ENDPOINT} user={user}>
            <App />
          </AuthProvider>
        </Router>
      </Provider>,
      document.getElementById("root")
    );
  })


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
